module.exports = __webpack_public_path__ + "img/img23.2ca591d2.jpg";